module.exports = __webpack_public_path__ + "static/painting-b08f28c43b442dfdbe18ba349b37066d.jpg";